export const POSITION_LEFT = "left";
export const POSITION_RIGHT = "right";
export const POSITION_CENTER = "center";
export type ImagePosition =
  | typeof POSITION_LEFT
  | typeof POSITION_RIGHT
  | typeof POSITION_CENTER;
